import { api } from '@/global/services/api'

const TAB_KEY = 'basicInfo'
const CONTACT_DATA_KEY = 'contacts'
const CONTACT_DISPLAY_PROPS = ['type_id', 'value']

export default {
  data () {
    return {
      basicInfoKey: TAB_KEY,
      contactsDataKey: CONTACT_DATA_KEY,
      contactTypes: []
    }
  },

  computed: {
    basicInfoCreateConfig () {
      return {
        title: this.$t('base/user.basic_info'),
        key: TAB_KEY,
        onLoad: () => this.onBasicInfoTabLoad(),
        validationErrors: this.validationErrors,
        tabContent: [
          {
            component: this.columnsContentComponent,
            title: this.$t('base/user.basic_info'),
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'first_name',
                    label: this.$t('base/user.first_name'),
                    autofocus: true,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'last_name',
                    label: this.$t('base/user.last_name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'username',
                    label: this.$t('base/user.username'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'email',
                    label: this.$t('base/user.email'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          {
            title: this.$t('base.user_contacts'),
            showButtons: false,
            component: this.dynamicColumnsContentComponent,
            key: CONTACT_DATA_KEY,
            display_props: CONTACT_DISPLAY_PROPS,
            headers: [this.$t('base/contact_type.type'), this.$t('base/contact_type.value')],
            fields: [
              {
                key: 'type_id',
                type: 'autocomplete',
                autocomplete_options: {
                  module: 'base',
                  route: 'contact-types/autocomplete',
                  fetchInitial: false
                },
                items: this.contactTypes,
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'value',
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    async onBasicInfoTabLoad () {
      try {
        const { data } = await api('base').get('contact-types/autocomplete')
        const { type_id: contactTypes } = data || {}
        if (contactTypes?.length) {
          this.contactTypes = contactTypes
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
